var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useDisclosure } from 'shared/components/ui';
import { useToast } from 'shared/components';
import { useState } from 'react';
import { useAppendNote } from './useAppendNote';
import { useForm } from 'react-hook-form';
import { validateAndFocusInvalidFields } from 'shared/utils';
import { useQueryClient } from 'react-query';
import { useAppendments } from './useAppendments';
import { ToastErrorBox } from 'shared/components/features/ToastErrorBox';
/**
 * Links together Buttons via appendActionsProps, and the append
 * form via appendFormProps.  Spread each over their components to give
 * This hook control over their interactions.
 */
export var useAppendForm = function (_a) {
    var _b;
    var noteId = _a.noteId;
    var form = useForm({});
    var _c = useState(0 /* NoteAppendMode.view */), appendMode = _c[0], setAppendMode = _c[1];
    var toast = useToast();
    var appendConfirmDisclosure = useDisclosure();
    var queryClient = useQueryClient();
    var appendments = useAppendments(noteId);
    var appendMutation = useAppendNote({
        noteId: noteId,
        onSuccess: function (data) {
            // edit the response data directly onto the cache
            var appendments = queryClient.getQueryData(['appendments', noteId]);
            queryClient.setQueryData(['appendments', noteId], __spreadArray([data], (appendments || []), true));
            // then invalidate to double check the state of things.
            queryClient.invalidateQueries(['appendments', noteId]);
            form.reset();
            setAppendMode(0 /* NoteAppendMode.view */);
        },
        onError: function (error) {
            var _a, _b;
            var message = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message;
            toast({
                status: 'error',
                position: 'top',
                duration: 15000,
                render: function (_a) {
                    var onClose = _a.onClose;
                    return (_jsx(ToastErrorBox, { onClose: onClose, title: "Failed to append note:", message: message }));
                },
            });
        },
    });
    /** Opens 'edit' mode */
    var appendNoteClick = function () {
        setAppendMode(1 /* NoteAppendMode.create */);
    };
    /** Closes 'edit' mode */
    var appendNoteCancelClick = function () {
        setAppendMode(0 /* NoteAppendMode.view */);
        form.reset();
    };
    /** Validates the append form and pops a confirmation dialog */
    var signAppendmentClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var isValid;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, validateAndFocusInvalidFields(form)];
                case 1:
                    isValid = _a.sent();
                    if (isValid) {
                        appendConfirmDisclosure.onOpen();
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    /** Fires when the user confirms the dialog */
    var appendConfirmed = function () {
        var data = form.getValues();
        appendMutation.mutate(data, {
            onSuccess: function () {
                form.reset();
            },
        });
    };
    var visible = appendMode === 1 /* NoteAppendMode.create */ || ((_b = appendments === null || appendments === void 0 ? void 0 : appendments.data) === null || _b === void 0 ? void 0 : _b.length) > 0;
    /** properties passed to the action buttons for appending. */
    var appendActionsProps = {
        appendMode: appendMode,
        appendMutation: appendMutation,
        appendNoteClick: appendNoteClick,
        appendNoteCancelClick: appendNoteCancelClick,
        signAppendmentClick: signAppendmentClick,
    };
    /** Properties passed to the append form */
    var appendFormProps = {
        appendMode: appendMode,
        appendMutation: appendMutation,
        appendConfirmDisclosure: appendConfirmDisclosure,
        appendConfirmed: appendConfirmed,
        form: form,
        visible: visible,
    };
    var appendHistoryProps = {
        visible: visible,
    };
    return {
        appendActionsProps: appendActionsProps,
        appendFormProps: appendFormProps,
        appendHistoryProps: appendHistoryProps,
    };
};
